/**
 * API Endpoints
 * Centralized endpoint definitions to prevent backend/frontend drift
 *
 * Backend API structure (from api/app/main.py):
 * - Base: /api/v1
 * - Auth router: /api/v1/auth
 * - Calculators: /api/v1/calculators
 */

export const API_ENDPOINTS = {
  /**
   * Authentication Endpoints
   * Mounted at /api/v1/auth in backend
   */
  AUTH: {
    // Authentication
    LOGIN: '/api/v1/auth/login',
    REFRESH: '/api/v1/auth/refresh',
    LOGOUT: '/api/v1/auth/logout',
    REGISTER: '/api/v1/auth/register',

    // Password management
    FORGOT_PASSWORD: '/api/v1/auth/forgot-password',
    RESET_PASSWORD: '/api/v1/auth/reset-password',
    CHANGE_PASSWORD: '/api/v1/auth/change-password',

    // User profile
    ME: '/api/v1/auth/me',
    UPDATE_PROFILE: '/api/v1/auth/users',
    DELETE_ACCOUNT: '/api/v1/auth/account',

    // OAuth
    GOOGLE_LOGIN: '/api/v1/auth/google/login',
    GOOGLE_CALLBACK: '/api/v1/auth/google/callback',

    // CSRF
    CSRF_TOKEN: '/api/v1/auth/csrf-token',
    AGENT_TOKEN: '/api/v1/auth/agent-token',
  },

  /**
   * Calculator Endpoints
   * Mounted at /api/v1/calculators in backend
   */
  CALCULATORS: {
    BASE_PLATE: '/api/v1/calculators/base_plate/calculate',
    // Add other calculators as they're implemented
  },

  /**
   * Report Endpoints
   */
  REPORTS: {
    GENERATE: '/api/v1/reports/generate',
    DOWNLOAD: '/api/v1/reports/download',
  },

  /**
   * PEB Optimizer Endpoints
   * Mounted at /api/v1/specialized/peb in backend
   */
  PEB: {
    // Legacy (local-agent / localhost) - kept for reference
    AGENT_HEALTH: '/api/v1/peb/agent/health',
    CURRENT_FILE: '/api/v1/peb/openstaad/current-file',
    OPTIMIZE_STREAM: '/api/v1/specialized/peb/optimize/stream',
    RUNS: '/api/v1/specialized/peb/runs',
    RUN_DETAIL: (runId: number): string => `/api/v1/specialized/peb/runs/${runId}`,

    // Outbound Poller (cloud queue - no localhost needed)
    QUEUE_START: '/api/v1/peb/queue/start',
    QUEUE_STATUS: (taskId: string): string => `/api/v1/peb/queue/status/${taskId}`,
    AGENT_POLL: '/api/v1/peb/agent/poll',
    AGENT_COMPLETE: '/api/v1/peb/agent/complete',
    AGENT_STATUS: '/api/v1/peb/agent/status',
  },
} as const;
